import SelectIcon from '~/components/icons/SelectIcon';

const Select = (originalProps) => {
  const { options, ...props } = originalProps;

  return (
    <div className="cb-select">
      <select {...props}>
        <option key={-1} />
        {options.map((option, i) => {
          return (
            <option key={i} value={option}>
              {option}
            </option>
          );
        })}
      </select>

      <SelectIcon className="cb-arrow" />
    </div>
  );
};

Select.propTypes = {
  options: PropTypes.array.isRequired,
  onBlur: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func.isRequired,
};

export default Select;
